import { getDvaApp } from 'umi';
import {
  showBindEmailModal,
  showBindPhoneModal,
  showLoginModal,
  showSetPwdModal,
} from '@/components/UserModal';
import * as UserModal from '@/components/UserModal/utils';

export { showBindEmailModal, showBindPhoneModal, showLoginModal, showSetPwdModal };

// 同步用户信息
// todo 脱离 getDvaApp
export const dispatchUserInfo = (param: any) => {
  const { dispatch } = getDvaApp()._store;
  const payload = {
    userInfo: param,
  };
  dispatch({ type: 'auth/setData', payload });
};

//  获取用户信息
export const getUserInfo = (isLogin: any = false) => {
  const userInfo = UserModal.getLocalZhiyinUser();
  if (!userInfo && isLogin) {
    // 弹出登录弹框
    UserModal.onShowLoginModal();
    showLoginModal();
  }
  // UserModal.openNoitce(userInfo, UserModal.initParam?.onClickPay); // 弹框提示
  return userInfo;
};

//  获取最新用户信息，不走缓存
export const getResetUserInfo = async () => {
  const result = UserModal.getResetUserInfo();
  return result;
};

//  获取token
export const getLocalToken = () => {
  return UserModal.getCookieToken();
};

// code 处理
export const fetchError = (code: any) => {
  UserModal.fetchError(code);

  // if ([200001, 100003, 200002, 200006].includes(code)) {
  //   currentShowLoginModal();
  // }
};

// 退出登录
export async function logout() {
  const res = await UserModal.logOut();
  if (res) {
    dispatchUserInfo(undefined); // 清空用户信息
    // location.reload();
    //页面重新加载
  }
  return res;
}

// 是否需要VIP
export function isShowVIPMenu(needVIP: boolean) {
  // const vipArr = ['关联技术', '领先学者', '领先机构', '领先地区']; // 这些是vip
  // let status = vipArr.includes(key);
  // if (needVIP && checkUserIsVIP()) {
  //   status = false;
  // }
  //  需要vip但是没有会员 展示menuvip
  return needVIP && !checkUserIsVIP();
}

// 用户是否为VIP
export function checkUserIsVIP() {
  const user = getUserInfo();
  // console.log("user.__isVip==>>>>",user,user?.__isVip)
  return user ? user.__isVip : false;
  // return false;
}
